import { normalizeFilters } from "@/forms/helpers";
import { formatSelectOptions } from "@/forms/validation";
import { parseSearchParamsChainOrNull } from "@/lib/utils";

export function createFilterModel(
  source: {
    medicalChamber: { [key: string]: string };
    province: { [key: string]: string };
  },
  searchParams: URLSearchParams,
) {
  const { medicalChamber: medicalChamberOptions, province: provinceOptions } =
    source;

  const medicalChamber = searchParams.get("medicalChamber");
  const province = searchParams.get("province");
  const q = searchParams.get("q");

  const fields: FiltersModel = {
    medicalChamber: {
      type: "multiselect",
      placeholder: "Wybierz izbę",
      options: formatSelectOptions(medicalChamberOptions),
      value: parseSearchParamsChainOrNull(medicalChamber),
    },
    province: {
      type: "multiselect",
      placeholder: "Wybierz województwo",
      options: formatSelectOptions(provinceOptions),
      value: parseSearchParamsChainOrNull(province),
    },
    q: {
      placeholder: "Wyszukaj",
      type: "text",
      value: q ?? null,
    },
  };

  return normalizeFilters(fields);
}
